import { Component, inject } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

export enum DoubleMondayModalResult {
	CONFIRM,
	DECLINE,
}

@Component({
	selector: 'app-double-monday-modal',
	imports: [IonicModule, TranslateModule],
	templateUrl: './double-monday-modal.html',
	styleUrl: './double-monday-modal.css',
})
export class DoubleMondayModal {
	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController): Promise<DoubleMondayModalResult> {
		console.log('DoubleMondayModal.show()');
		const modal = await modalCtrl.create({
			component: DoubleMondayModal,
			cssClass: 'double-monday-modal',
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data as DoubleMondayModalResult;
		if (!!result) {
			return DoubleMondayModalResult.DECLINE;
		}
		return result;
	}

	onConfirmClick() {
		this.modalCtrl.dismiss(DoubleMondayModalResult.CONFIRM);
	}
	onDeclineClick() {
		this.modalCtrl.dismiss(DoubleMondayModalResult.DECLINE);
	}
}
